import React, {
  useCallback,
  useMemo,
  useContext,
  useEffect,
  memo,
} from 'react';
import { IClientBusinessModel } from '../../../Types/ClientModelTypes';
import {
  IMasterCompProps,
  TSelectedDetail,
} from '../../../Types/MasterDetailTypes';
import { IUIUrval, RutinUrvalType } from '../../../Types/UrvalTypes';
import BusinessDataSet from '../_Common/Components/BusinessCollectionComponents/BusinessDataSet/BusinessDataSet';
import EDView from '../../../BaseComponents/View/EDView';
import { createPortal } from 'react-dom';
import BusinessDataDetailHeader from '../_Common/Components/BusinessCollectionComponents/BusinessDataDetailHeader/BusinessDataDetailHeader';
import { IColumnDef } from '../../../Types/ColumnDefType';
import { ICollectionDataType } from '../_Common/Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { useSet } from '../../../Hooks/arrayHooks';
import {
  BreadcrumbsContext,
  HEADER,
} from '../_Common/Components/RutinBreadcrumbs/BreadcrumbsContext';
import EDBreadcrumb from '../../../BaseComponents/Breadcrumb/EDBreadcrumb';
import EDIconButton from '../../../BaseComponents/Buttons/IconButton/EDIconButton';
import { makeStyles } from 'tss-react/mui';
import {
  Theme,
  ThemeProvider,
  StyledEngineProvider,
  Breakpoint,
} from '@mui/material';
import {
  sortRows,
  standardRutinGetSortValue,
  standardRutinCompare,
  ISortProperty,
} from '../../../BaseComponents/Table/Components/SortableTableUtils';
import { RutinSettingsContext } from '../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { getRutinPanelFullHeight, rutiner } from '../_Common/Const/Rutiner';
import RutinUrvalListQuery from '../../../Components/Urval/Components/SavedUrval/Queries/RutinUrvalListQuery/RutinUrvalListQuery';
import { VisningsTypContext } from '../_Common/Components/BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';
import { StandardRutinContext } from './StandardRutinContext';
import {
  useBusinessCollectionMenuItemsType,
  useItemFunctionMenuItemsType,
} from '../../../Utils/ObjektVyUtils';
import ListFilteringComponent from '../_Common/Components/ListFilteringComponent/ListFilteringComponent';
import { IFilterAttribute } from '../_Common/Const/Delsystem';
import usePrevious from '../../../Hooks/usePrevious';
import {
  APP_HEADER_TOTAL_HEIGHT_PX,
  AvenyThemeDark,
} from '../../../BaseComponents/ThemeProvider/AvenyTheme';
import { rutinInfos } from '../_Common/Const/RutinInfo';
import { IRutinInfo } from '../../../Types/RutinInfoType';
import { InternalError } from '../../../Components/InternalError/InternalError';
import { findRutinOrStyrvärde } from '../_Common/Utils/RutinUtils';
import {
  NewId,
  NO_ID_AVAILABLE,
  selectedId,
} from '../../../Components/MasterDetail/MasterDetailUtils';
import RouterLink from '../../../Components/RouterLink/RouterLink';
import {
  buildBasePath,
  useBaseRouteValue,
} from '../../Routing/Utils/routerUtils';
import { useNavigate, useResolvedPath } from 'react-router';
import EDBox from '../../../BaseComponents/EDBox/EDBox';
import { filterData } from '../_Common/Components/ListFilteringComponent/Utils/listFilterComponentUtils';
import { SchedulerFilterContextProvider } from '../Bokning/Rutiner/Kalender/Components/SchedulerComponent/SchedulerFilterContext';
import {
  breakpointIsLarger,
  breakpointIsLargerOrEqual,
  useWidth,
} from '../../../Components/BreakpointContext/BreakpointContextUtils';
import SelectionNameLabel from '../_Common/Components/SelectionNameLabel/SelectionNameLabel';
import { ActiveDatabaseContext } from '../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { StandardRutinCollectionContext } from './StandardRutinCollectionContext';
import { SelectNewDetailType } from './StandardRutin';
import { checkTrailingSlash } from '../../../Utils/utils';

interface IProps {
  collection: IClientBusinessModel;
  activeRoutine?: IRutinInfo;
  initialUrval?: string;
  columns: readonly IColumnDef[];
  setColumns: (newColumns: readonly IColumnDef[]) => void;
  urval: IUIUrval | null;
  urvalId?: string;
  setUrval: React.Dispatch<React.SetStateAction<IUIUrval | null>>;
  value: {
    data: ICollectionDataType[] | null;
    refetch: () => void;
    loading: boolean;
  };
  selectDetail: (
    id: TSelectedDetail,
    force?: boolean,
    urlParams?: Record<string, string>
  ) => void;
  selectedId: TSelectedDetail;
  inlineDetail?: React.ReactNode;
  setSelectDetailByIndex?: (
    selectDetailByIndex: (index: number) => void
  ) => void;
  detailHeader?: Element;
  // Temp until implementation is decided upon
  showCheckboxes?: boolean;
  debug?: boolean;
  rutinUrvalList: RutinUrvalType[] | null | undefined;
  loading: boolean;
  useFunktionsMenyItems?: useItemFunctionMenuItemsType;
  useBusinessCollectionMenuItems?: useBusinessCollectionMenuItemsType;
  searchText: string;
  setSearchText: (newValue: string) => void;
  filterAttributes: IFilterAttribute[] | undefined;
  rutinKod: string;
  selectNextDetail: any;
  formStateRef: any;
  masterSelectNextDetail?: (force?: boolean) => void;
  masterSelectPreviousDetail?: () => void;
  //från EnhancedStandardRutinMasterView
}
interface IInnerProps extends IProps {
  visningsTypContext: any;
  rutinAvailabilityContext: any;
  standardRutinCollectionContext: any;
  width: Breakpoint;
  // BreadCrumbsContext: IBreadcrumbsContext;
}

interface IWrappedProps extends IMasterCompProps {
  collection: IClientBusinessModel;
  activeRoutine?: IRutinInfo;
  rutinUrvalListLoading: boolean;
  rutinUrvalList?: RutinUrvalType[] | null;
  showCheckboxes: boolean;
  useFunctionMenuItems?: useItemFunctionMenuItemsType;
  useBusinessCollectionMenuItems?: useBusinessCollectionMenuItemsType;
  rutinKod: string;
}

const useStyles = makeStyles()((theme: Theme) => ({
  drawerPaper: {
    top: APP_HEADER_TOTAL_HEIGHT_PX,
    height: `calc(100% - ${APP_HEADER_TOTAL_HEIGHT_PX}px)`,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  contentContainerCardsDisplayRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },
  contentSubContainer: {
    display: 'flex',
    justifyContent: 'center',
    flex: '1 1 auto',
    height: '100px',
  },
  contentSubContainerFullHeight: {
    height: '100%',
  },
  paddingRightCardLargeScreen: {
    paddingRight: theme.spacing(1),
  },
  paddingRightCardSmallScreen: {
    paddingRight: theme.spacing(0),
    paddingLeft: theme.spacing(0),
  },
  menuButton: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.75),
  },
  contentSubContainerSmall: {
    overflow: 'hidden',
  },
  showDetailRightMenu: {},

  filterContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  kalenderCustomFilterStyle: {
    '& > :first-of-type': {
      '& > :first-of-type': {
        '& > :first-of-type': {
          '& > :first-of-type': {
            minWidth: '350px !important',
          },
        },
      },
    },
  },
}));

/**
 * Bakåtnavigering till startvyn från rutinnivån.
 */
const BackLink = () => {
  const baseRouteValues = useBaseRouteValue();
  return (
    <RouterLink to={buildBasePath(baseRouteValues)}>
      <EDIconButton
        icon="arrow_back"
        testId="backButton-Start"
        color="inherit"
        tooltip="Start"
        padding="dense"
        marginTop={0.5}
        marginBottom={0.5}
      />
    </RouterLink>
  );
};

interface INavProps {
  selectedId: TSelectedDetail;
  activeRoutine?: IRutinInfo;
  collection: any; // replace with actual type
  columns: any; // replace with actual type
  value: any; // replace with actual type
  selectDetail: (id: TSelectedDetail, force?: boolean) => void;
  currentIndex: number;
  rutinKod: string;
  standardRutinCollectionContext: any;
  isExtraSmall: boolean;
  selectNextDetail?: (force?: boolean) => void;
  selectPreviousDetail?: () => void;
  showDetailsRight?: boolean;
}

const StandardRutinMasterNavComponents: React.FC<
  React.PropsWithChildren<INavProps>
> = props => {
  const navigate = useNavigate();
  const baseUrl = checkTrailingSlash(useResolvedPath('.').pathname);

  const { selectDetail } = props;
  const unselectDetail = useCallback(() => selectDetail(null), [selectDetail]);
  const onRoutineBreadcrumbClick = useCallback(() => {
    if (!props.selectedId) {
      return;
    }

    if (props.showDetailsRight) {
      navigate(baseUrl);
      return;
    }

    unselectDetail();
  }, [
    props.selectedId,
    props.showDetailsRight,
    navigate,
    baseUrl,
    unselectDetail,
  ]);

  const {
    headerReferences,
    backButtonReferences,
    stepperReferences,
    stepperSmallRef,
    topNavLevel,
    registerActiveNavLevel,
    unregisterActiveNavLevel,
  } = useContext(BreadcrumbsContext);
  const listHeaderRef = headerReferences?.[0];
  const detailHeaderRef = headerReferences?.[1];
  const listBackRef = backButtonReferences?.[0];
  const detailBackRef = backButtonReferences?.[1];
  const stepperRef = props.isExtraSmall
    ? stepperSmallRef
    : stepperReferences?.[1];

  useEffect(() => {
    registerActiveNavLevel(0);
    return () => unregisterActiveNavLevel(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderDetail = Boolean(detailHeaderRef && props.selectedId);
  const showInBreadcrumb = !props.showDetailsRight;
  useEffect(() => {
    if (renderDetail) {
      registerActiveNavLevel(1, showInBreadcrumb);
      return () => unregisterActiveNavLevel(1, showInBreadcrumb);
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderDetail, showInBreadcrumb]);
  return (
    <>
      {
        //!props.selectedId &&
        listBackRef && createPortal(<BackLink />, listBackRef)
      }
      {/* // Bakåtknapp till innehållslista */}
      {props.selectedId &&
        !props.showDetailsRight &&
        detailBackRef &&
        (topNavLevel ?? 0) <= 1 &&
        createPortal(
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={AvenyThemeDark}>
              <EDIconButton
                icon="arrow_back"
                testId="backButton-Innehållslista"
                iconColor={'inherit'}
                tooltip={'Innehållslista'}
                padding="dense"
                marginTop={0.5}
                marginBottom={0.5}
                onClick={unselectDetail}
              />
            </ThemeProvider>
          </StyledEngineProvider>,
          detailBackRef
        )}
      {/* rutinnamn som länk i breadcrumb */}
      {listHeaderRef?.[HEADER]?.current &&
        createPortal(
          <EDBreadcrumb
            onClick={props.selectedId ? onRoutineBreadcrumbClick : undefined}
            caption={props.activeRoutine?.benamning ?? '---'}
          />,
          listHeaderRef[HEADER].current
        )}
      {renderDetail && detailHeaderRef && (
        <BusinessDataDetailHeader
          collection={props.collection}
          columns={props.columns}
          data={
            props.standardRutinCollectionContext.filteredSortInfo.rows.length >
            0
              ? props.standardRutinCollectionContext.filteredSortInfo.rows
              : props.value.data
          }
          selectDetail={props.selectDetail}
          selectedId={selectedId(props.selectedId)}
          currentIndex={props.currentIndex}
          next={props.selectNextDetail}
          prev={props.selectPreviousDetail}
          currentlyOpen={topNavLevel === 1}
          headerRef={detailHeaderRef}
          stepperRef={stepperRef}
          rutinKod={props.rutinKod}
          disableBreadcrumbLink={props.showDetailsRight}
        />
      )}
    </>
  );
};

export interface ICurrentSorting {
  /** Vilka properties den aktuella sorteringen utgått från */
  properties?: ISortProperty[];
  /** Map med sorteringsordning per id */
  sortOrder?: Map<string, number>;
}

const StandardRutinMasterView = memo((props: IInnerProps) => {
  const { selectDetail } = props;
  const showSelectionName = Boolean(
    rutiner[props.activeRoutine?.rutinKod || '']?.showSelectionNameInList
  );
  const hasUrval = Boolean(props.urval);
  const isLargeScreen = breakpointIsLargerOrEqual('md', props.width);
  const isExtraSmall = props.width === 'xs';

  const updateFilteredResult = useCallback(
    (newText: string) => {
      if (isLargeScreen) {
        const newFilteredSortInfo = filterData(
          props.collection.CollectionName,
          props.standardRutinCollectionContext.sortInfo,
          newText,
          props.filterAttributes,
          hasUrval,
          props.loading
        );

        if (
          props.visningsTypContext.showDetailsRight &&
          !newFilteredSortInfo.rows.find(x => x.id === props.selectedId)
        ) {
          selectDetail(newFilteredSortInfo.rows?.[0]?.id);
        }
      }
    },
    [
      isLargeScreen,
      props.standardRutinCollectionContext.sortInfo,
      props.filterAttributes,
      props.selectedId,
      selectDetail,
      hasUrval,
      props.loading,
      props.visningsTypContext.showDetailsRight,
      props.collection.CollectionName,
    ]
  );

  useEffect(() => {
    const rows = sortRows(
      props.standardRutinCollectionContext.sortInfo.properties,
      props.value.data || [],
      standardRutinGetSortValue(props.collection.CollectionName),
      standardRutinCompare
    );
    const selectedDetailFromData = props.value?.data?.find(
      collectionDataItem =>
        collectionDataItem.id === selectedId(props.selectedId)
    );
    //Vid visning till höger väljer vi automatiskt första posten om ingen är vald innan
    if (
      props.visningsTypContext.showDetailsRight &&
      (!props.selectedId || !selectedDetailFromData)
    ) {
      if (rows.length > 0) {
        props.selectDetail({
          id: rows.at(0)?.id ?? NO_ID_AVAILABLE,
          nextId: rows.at(1)?.id ?? null,
          prevId: null,
          data: rows.at(0),
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value, props.loading]);

  const [selected, toggleSelected] = useSet<string>();

  const currentIndex = useMemo(() => {
    let sortedList =
      props.standardRutinCollectionContext.filteredSortInfo.rows.length > 0
        ? props.standardRutinCollectionContext.filteredSortInfo
        : props.standardRutinCollectionContext.sortInfo;
    return sortedList.rows.findIndex(
      (data: any) => data.id === selectedId(props.selectedId)
    );
  }, [
    props.standardRutinCollectionContext.filteredSortInfo,
    props.standardRutinCollectionContext.sortInfo,
    props.selectedId,
  ]);

  const selectNewDetail: SelectNewDetailType = useCallback(
    (customDetailData, urlParams) =>
      selectDetail(
        { id: NewId, customDetailData: customDetailData },
        undefined,
        urlParams
      ),
    [selectDetail]
  );

  const { classes, cx } = useStyles();

  const rutinPanelFullheight = getRutinPanelFullHeight(
    props.rutinAvailabilityContext.activeRoutine?.routine.rutinKod
  );

  const hideStandardListFilter =
    rutiner[props.activeRoutine?.rutinKod || '']?.hideStandardListFilter;

  const routineSettingShowListFilter =
    typeof hideStandardListFilter === 'boolean' ||
    hideStandardListFilter == null
      ? !hideStandardListFilter
      : breakpointIsLarger(hideStandardListFilter, props.width);

  const showListFilteringComponent =
    props.filterAttributes !== undefined && routineSettingShowListFilter;

  const SelectionNameComp = showSelectionName ? (
    <SelectionNameLabel
      collection={props.collection}
      rutinUrvalList={props.rutinUrvalList}
      urval={props.urval}
      urvalID={props.urvalId}
    />
  ) : null;

  let hideDefaultFunktionsMenyItems =
    rutiner[props.activeRoutine?.rutinKod || '']
      ?.hideDefaultFunktionsMenyItems ?? false;

  useEffect(() => {
    props.selectNextDetail.current = (force: boolean) => {
      if (props.masterSelectNextDetail) {
        props.masterSelectNextDetail(force);
      } else {
        props.selectDetail(null, force);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.masterSelectNextDetail, props.selectDetail]);

  return (
    <SchedulerFilterContextProvider
      onSearchTextChanged={(text: string): void => {
        props.setSearchText(text);
        updateFilteredResult(text);
      }}
      searchText={props.searchText}
      sortedData={props.standardRutinCollectionContext.sortInfo}
      filterAttributes={props.filterAttributes}
      filterAttributesPlacholder={`Filtrera på t.ex. ${props.filterAttributes
        ?.map((attr: { label: any }) => attr.label)
        .join(', ')
        .replace(/, (?!.*, )/, ' eller ')}`} // sista ", " i strängen
      visningsTyp={props.visningsTypContext.visningsTyp}
      listlength={props.standardRutinCollectionContext.sortInfo.rows.length}
      sortedLength={
        props.standardRutinCollectionContext.filteredSortInfo.rows.length
      }
    >
      <div
        className={
          props.visningsTypContext.visningsTyp === 'kort' &&
          props.visningsTypContext.showDetailsRight
            ? classes.contentContainerCardsDisplayRight
            : classes.contentContainer
        }
      >
        <EDView
          className={cx(classes.contentSubContainer, {
            [classes.contentSubContainerFullHeight]:
              rutinPanelFullheight && breakpointIsLarger('sm', props.width),
            [classes.contentSubContainerSmall]: isExtraSmall,
            [classes.paddingRightCardLargeScreen]:
              props.visningsTypContext.visningsTyp === 'kort' && !isExtraSmall,
            [classes.paddingRightCardSmallScreen]:
              props.visningsTypContext.visningsTyp === 'kort' && isExtraSmall,
          })}
        >
          {props.filterAttributes !== undefined &&
          showListFilteringComponent ? (
            <div className={classes.filterContainer}>
              <ListFilteringComponent
                onSearchTextChanged={(text: string): void => {
                  props.setSearchText(text);
                  updateFilteredResult(text);
                }}
                searchText={props.searchText}
                sortedData={props.standardRutinCollectionContext.sortInfo}
                filterAttributes={props.filterAttributes}
                filterAttributesPlacholder={`Filtrera på ${props.filterAttributes
                  .map(attr => attr.label)
                  .join(', ')
                  .replace(/, (?!.*, )/, ' eller ')}`} // sista ", " i strängen
                visningsTyp={props.visningsTypContext.visningsTyp}
                listlength={
                  props.standardRutinCollectionContext.sortInfo.rows.length
                }
                sortedLength={
                  props.standardRutinCollectionContext.filteredSortInfo.rows
                    .length
                }
                selectionNameComp={SelectionNameComp}
              />
              <BusinessDataSet
                collection={props.collection}
                columns={props.columns}
                setColumns={props.setColumns}
                urval={props.urval}
                urvalId={props.initialUrval}
                setUrval={props.setUrval}
                refetch={props.value.refetch}
                loading={props.loading}
                selectDetail={props.selectDetail}
                selectNewDetail={selectNewDetail}
                selectedId={props.selectedId}
                inlineDetail={props.inlineDetail}
                selected={selected}
                toggleSelected={toggleSelected}
                showCheckboxes={props.showCheckboxes}
                sortedData={
                  props.standardRutinCollectionContext.filteredSortInfo
                }
                updateSortOrder={
                  props.standardRutinCollectionContext.updateSortInfo
                }
                useFunktionsMenyItems={props.useFunktionsMenyItems}
                settingsId={`StandardRutinMaster-${props.rutinKod}`}
                hideDefaultFunktionsMenyItems={hideDefaultFunktionsMenyItems}
              />
            </div>
          ) : (
            <div className={classes.filterContainer}>
              {SelectionNameComp && (
                <EDBox padding={1}>{SelectionNameComp}</EDBox>
              )}
              <BusinessDataSet
                collection={props.collection}
                columns={props.columns}
                setColumns={props.setColumns}
                urval={props.urval}
                setUrval={props.setUrval}
                refetch={props.value.refetch}
                loading={props.loading}
                selectDetail={props.selectDetail}
                selectNewDetail={selectNewDetail}
                selectedId={selectedId(props.selectedId)}
                inlineDetail={props.inlineDetail}
                selected={selected}
                toggleSelected={toggleSelected}
                showCheckboxes={props.showCheckboxes}
                sortedData={
                  props.standardRutinCollectionContext.filteredSortInfo
                }
                updateSortOrder={
                  props.standardRutinCollectionContext.updateSortInfo
                }
                useFunktionsMenyItems={props.useFunktionsMenyItems}
                settingsId={`StandardRutinMaster-${props.rutinKod}`}
                hideDefaultFunktionsMenyItems={hideDefaultFunktionsMenyItems}
              />
            </div>
          )}
        </EDView>
        <StandardRutinMasterNavComponents
          activeRoutine={props.activeRoutine}
          collection={props.collection}
          columns={props.columns}
          currentIndex={currentIndex}
          selectDetail={props.selectDetail}
          selectedId={props.selectedId}
          rutinKod={props.rutinKod}
          value={props.value}
          standardRutinCollectionContext={props.standardRutinCollectionContext}
          isExtraSmall={isExtraSmall}
          selectNextDetail={props.masterSelectNextDetail}
          selectPreviousDetail={props.masterSelectPreviousDetail}
          showDetailsRight={props.visningsTypContext.showDetailsRight}
        />
      </div>
    </SchedulerFilterContextProvider>
  );
});

const EnhancedStandardRutinMasterView: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const width = useWidth();
  const isSmall = width === 'xs';
  const previousSelectedId = usePrevious(props.selectedId);
  const visningsTypContext = useContext(VisningsTypContext);
  const rutinAvailabilityContext = useContext(RutinSettingsContext);
  const standardRutinCollectionContext = useContext(
    StandardRutinCollectionContext
  );
  const refetch = props.value.refetch;

  /** För dem flesta rutiner villa vi uppdatera BusinessDataSet visningen när vi återgår till StandardRutinMaster från en detail*/
  useEffect(() => {
    const rutin = findRutinOrStyrvärde(props.activeRoutine?.rutinKod || '');
    if (
      previousSelectedId &&
      !props.selectedId &&
      (isSmall ? rutin?.optInDataRefreshMobile : rutin?.optInDataRefreshDesktop)
    ) {
      refetch();
    }
  }, [
    previousSelectedId,
    props.selectedId,
    refetch,
    isSmall,
    props.activeRoutine,
  ]);
  return (
    <StandardRutinMasterView
      visningsTypContext={visningsTypContext}
      rutinAvailabilityContext={rutinAvailabilityContext}
      standardRutinCollectionContext={standardRutinCollectionContext}
      width={width}
      {...props}
    />
  );
};

const WrappedStandardRutinMaster: React.FC<
  React.PropsWithChildren<IWrappedProps>
> = props => {
  const {
    columns,
    setColumns,
    urval,
    setUrval,
    selectNextDetail,
    formStateRef,
  } = useContext(StandardRutinContext);
  const rutinAvailabilityContext = useContext(RutinSettingsContext);
  const standardRutinCollectionContext = useContext(
    StandardRutinCollectionContext
  );

  let initialUrval = rutiner[props.activeRoutine?.rutinKod || '']?.initialUrval;
  if (rutinAvailabilityContext.hasRutinStartError) {
    initialUrval = '';
  }

  const urvalId = useMemo(
    () => urval?.savedUrvalProps?.id ?? initialUrval,
    [initialUrval, urval?.savedUrvalProps?.id]
  );

  return (
    <EnhancedStandardRutinMasterView
      collection={props.collection}
      activeRoutine={props.activeRoutine}
      columns={columns}
      initialUrval={initialUrval}
      setColumns={setColumns}
      urval={urval}
      urvalId={urvalId}
      setUrval={setUrval}
      value={standardRutinCollectionContext.collectionQueryResult}
      selectDetail={props.selectDetail}
      selectedId={props.selectedDetail}
      inlineDetail={props.inlineDetail}
      setSelectDetailByIndex={props.setSelectDetailByIndex}
      detailHeader={props.detailHeader}
      showCheckboxes={props.showCheckboxes}
      rutinUrvalList={props.rutinUrvalList}
      loading={standardRutinCollectionContext.collectionQueryResult.loading}
      useFunktionsMenyItems={props.useFunctionMenuItems}
      useBusinessCollectionMenuItems={props.useBusinessCollectionMenuItems}
      searchText={standardRutinCollectionContext.searchText}
      setSearchText={standardRutinCollectionContext.setSearchText}
      filterAttributes={standardRutinCollectionContext.filterAttributes}
      rutinKod={props.rutinKod}
      selectNextDetail={selectNextDetail}
      formStateRef={formStateRef}
      masterSelectNextDetail={props.selectNextDetail}
      masterSelectPreviousDetail={props.selectPreviousDetail}
    />
  );
};

const StandardRutinMaster =
  (
    collection: IClientBusinessModel,
    rutinKod: string,
    // Temp until implementation is decided upon
    showCheckboxes?: boolean,
    startWithEmptyUrval?: boolean,
    useFunktionsMenyItems?: useItemFunctionMenuItemsType,
    useBusinessCollectionMenuItems?: useBusinessCollectionMenuItemsType
  ) =>
  (props: IMasterCompProps) => {
    const activeRoutine: IRutinInfo | undefined = rutinInfos[rutinKod];

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const activeDatabaseContext = useContext(ActiveDatabaseContext);

    return activeRoutine ? (
      <RutinUrvalListQuery
        collectionName={collection.CollectionName}
        routineID={rutinInfos[rutinKod]?.rutinID}
        kodplanUrval={false}
      >
        {({ rutinUrvalList, loading: rutinUrvalListLoading }) => {
          if (activeDatabaseContext.activeDatabaseInfoLoading) {
            return <></>;
          }

          return (
            <WrappedStandardRutinMaster
              collection={collection}
              activeRoutine={activeRoutine}
              rutinUrvalListLoading={rutinUrvalListLoading}
              rutinUrvalList={rutinUrvalList}
              showCheckboxes={Boolean(showCheckboxes)}
              useFunctionMenuItems={useFunktionsMenyItems}
              useBusinessCollectionMenuItems={useBusinessCollectionMenuItems}
              rutinKod={rutinKod}
              {...props}
            />
          );
        }}
      </RutinUrvalListQuery>
    ) : (
      <InternalError
        id="da57d61a-5e8f-4875-a3a2-e3d140cff2f3"
        message={`rutinkod ${rutinKod} saknas`}
      />
    );
  };

export default StandardRutinMaster;
